import { adminHttpClient } from "../../../commons/adminHttpClinet";

const pauseAllGoals = (userId: string, ): Promise<any> => {
    return adminHttpClient.put(`/api/Admin/AdminGoals/pause-all-goal?userId=${userId}`,null)
}
export default pauseAllGoals;